import PropChainTracker from "../../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjGen from "../../../prop-tracker-utils/dict-tracker-obj-gen.js";

import SkeletonTrackerCreator from "./skeletons/skeleton-tracker-creator.js";

class SkeletonLoading {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, skeletonLoader) {
        this._sklDataTracker = new PropChainTracker(evtCtx);
        this._sklTrackLoader = new SkeletonTrackerCreator(this._sklDataTracker, evtCtx, shlWrapCtx, shlEvtCtx, skeletonLoader);
        const sklGen = new DictTrackerObjGen(shlWrapCtx, shlEvtCtx, this._sklTrackLoader);

        this._skeletons = Object.freeze({
            all: sklGen,
        });
    }

    get skeletons() { return this._skeletons; }

    track(skeletonData, objects) {
        if (skeletonData) {
            this._sklDataTracker.track(skeletonData.data, ["value"]);
        } else {
            this._sklDataTracker.track();
        }

        if (objects) {
            this._sklTrackLoader.trackObjects(objects.data, objects.events);
        } else {
            this._sklTrackLoader.trackObjects();
        }
    }

    update() {
        this._skeletons.all.update();
    }
}

export default SkeletonLoading;
